import { Routes } from '@angular/router';
import { provideInvestmentStrategyStore } from '@zero/onboarding/domain';

export const INVESTMENT_STRATEGY_ROUTES: Routes = [
  {
    path: '',
    redirectTo: 'auswahl',
    pathMatch: 'full',
  },
  {
    path: 'auswahl',
    loadComponent: () => import('./pages/investment-strategy-choice/investment-strategy-choice.component'),
    providers: [provideInvestmentStrategyStore()],
    data: { shouldHideHeaderAndFooter: true, animation: 'InvestmentStrategyChoicePage' },
  },
  {
    path: 'erfolgreich',
    loadComponent: () => import('./pages/investment-strategy-success/investment-strategy-success.component'),
    data: { shouldHideHeaderAndFooter: true, animation: 'InvestmentStrategySuccessPage' },
  },
];
